import { Locales } from '@ratehub/base-ui';
import { PATHS } from '@ratehub/web-components';

import createMortgageAgentDetailsStaticProps from '../functions/createMortgageAgentDetailsStaticProps';
import withFrenchLocale from '../functions/withFrenchLocale';
import MortgageAgentDetailsPage from '../components/MortgageAgentDetailsPage';


const { getStaticPaths, getStaticProps } = createMortgageAgentDetailsStaticProps({
    locale: Locales.FRENCH,
    fileName: 'mtgAgentDetailsFR',
    path: PATHS.AGENT_DETAILS_FR,
});

export default withFrenchLocale(MortgageAgentDetailsPage);
export { getStaticPaths, getStaticProps };

